import { Calendar, Clock, BookOpen , Plus, ChevronUp, ChevronDown } from "lucide-react";
import { useState } from "react";
import { useTheme } from "../../../hooks/fetch_api_hook/useTheme";
import MathText from "../../VueQuestion/MathText";
import { attendusDeRubrique } from "../../../utils/rubriqueAttendus";
const PreviewSequence = ({ sequencesWithDates, periodes, selectedNiveau,ThemeDetail,
  selectedAttendus,setSelectedAttendus,
  handleBackStep , setApiData , setEtape}) => {
   const [expandedSequence, setExpandedSequence] = useState(null);
  
  const [expandedDescripteurs, setExpandedDescripteurs] = useState({});



// Fonction pour obtenir la couleur du badge selon le thème
function getThemeBadgeColor(theme) {
  const normalizedTheme = typeof theme === "string" 
    ? theme
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .trim()
    : "";
    
  switch (normalizedTheme) {
    // MATHS - Rouge : Nombre/Calculs
    case "NOMBRE ET CALCULS":
    case "NOMBRE, CALCUL ET RESOLUTION DE PROBLEMES":
      return "bg-red-100 text-red-700 border-red-300";

    // MATHS - Bleu : Espace et Géométrie
    case "ESPACE ET GEOMETRIE":
      return "bg-blue-100 text-blue-700 border-blue-300";

    // MATHS - Emerald : Grandeurs et mesures
    case "GRANDEURS ET MESURES":
      return "bg-emerald-100 text-emerald-700 border-emerald-300";

    // MATHS - Purple : Organisation et gestion de données
    case "ORGANISATION ET GESTION DE DONNEES":
    case "ORGANISATION ET GESTION DE DONNEES, FONCTIONS":
    case "ORGANISATION ET GESTION DE DONNEES ET PROBABILITES":
      return "bg-purple-100 text-purple-700 border-purple-300";

    // MATHS - Zinc : Algorithmique
    case "ALGORITHMIQUE ET PROGRAMMATION":
    case "INITIATION A LA PENSEE INFORMATIQUE":
      return "bg-zinc-100 text-zinc-700 border-zinc-300";

    // MATHS - Orange : Proportionnalité
    case "LA PROPORTIONNALITE":
      return "bg-orange-100 text-orange-700 border-orange-300";

    // FRANÇAIS - Indigo : Langage Oral
    case "LANGAGE ORAL":
      return "bg-indigo-100 text-indigo-700 border-indigo-300";

    // FRANÇAIS - Teal : Lecture
    case "LECTURE":
    case "LECTURE ET COMPREHENSION DE L'ECRIT":
      return "bg-teal-100 text-teal-700 border-teal-300";

    // FRANÇAIS - Amber : Écriture
    case "ECRITURE":
      return "bg-amber-100 text-amber-700 border-amber-300";

    // FRANÇAIS - Cyan : Vocabulaire
    case "VOCABULAIRE":
      return "bg-cyan-100 text-cyan-700 border-cyan-300";

    // FRANÇAIS - Rose : Grammaire/Étude de la langue
    case "GRAMMAIRE ET ORTHOGRAPHE GRAMMATICALE":
    case "ETUDE DE LA LANGUE":
      return "bg-rose-100 text-rose-700 border-rose-300";

    // FRANÇAIS - Violet : Culture littéraire
    case "CULTURE LITTERAIRE ET ARTISTIQUE":
      return "bg-violet-100 text-violet-700 border-violet-300";

    default:
      return "bg-gray-100 text-gray-700 border-gray-300";
  }
}

// Fonction pour obtenir la bordure gauche colorée
function getThemeBorderColor(theme) {
  const normalizedTheme = typeof theme === "string" 
    ? theme
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .trim()
    : "";
    
  switch (normalizedTheme) {
    // MATHS
    case "NOMBRE ET CALCULS":
    case "NOMBRE, CALCUL ET RESOLUTION DE PROBLEMES":
      return "border-red-500";
    case "ESPACE ET GEOMETRIE":
      return "border-blue-500";
    case "GRANDEURS ET MESURES":
      return "border-emerald-500";
    case "ORGANISATION ET GESTION DE DONNEES":
    case "ORGANISATION ET GESTION DE DONNEES, FONCTIONS":
    case "ORGANISATION ET GESTION DE DONNEES ET PROBABILITES":
      return "border-purple-500";
    case "ALGORITHMIQUE ET PROGRAMMATION":
    case "INITIATION A LA PENSEE INFORMATIQUE":
      return "border-zinc-500";
    case "LA PROPORTIONNALITE":
      return "border-orange-500";
      
    // FRANÇAIS
    case "LANGAGE ORAL":
      return "border-indigo-500";
    case "LECTURE":
    case "LECTURE ET COMPREHENSION DE L'ECRIT":
      return "border-teal-500";
    case "ECRITURE":
      return "border-amber-500";
    case "VOCABULAIRE":
      return "border-cyan-500";
    case "GRAMMAIRE ET ORTHOGRAPHE GRAMMATICALE":
    case "ETUDE DE LA LANGUE":
      return "border-rose-500";
    case "CULTURE LITTERAIRE ET ARTISTIQUE":
      return "border-violet-500";
      
    default:
      return "border-gray-500";
  }
}

// Fonction pour obtenir le nom court du thème
function getShortThemeName(theme) {
  const normalizedTheme = typeof theme === "string" 
    ? theme
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .trim()
    : "";

  switch (normalizedTheme) {
    // MATHS
    case "NOMBRE ET CALCULS":
    case "NOMBRE, CALCUL ET RESOLUTION DE PROBLEMES":
      return "Nombres & Calculs";
    case "ESPACE ET GEOMETRIE":
      return "Espace & Géométrie";
    case "GRANDEURS ET MESURES":
      return "Grandeurs & Mesures";
    case "ORGANISATION ET GESTION DE DONNEES":
    case "ORGANISATION ET GESTION DE DONNEES, FONCTIONS":
    case "ORGANISATION ET GESTION DE DONNEES ET PROBABILITES":
      return "OGD";
    case "ALGORITHMIQUE ET PROGRAMMATION":
      return "Algo & Prog";
    case "INITIATION A LA PENSEE INFORMATIQUE":
      return "Informatique";
    case "LA PROPORTIONNALITE":
      return "Proportionnalité";
      
    // FRANÇAIS
    case "LANGAGE ORAL":
      return "Oral";
    case "LECTURE":
    case "LECTURE ET COMPREHENSION DE L'ECRIT":
      return "Lecture";
    case "ECRITURE":
      return "Écriture";
    case "VOCABULAIRE":
      return "Vocabulaire";
    case "GRAMMAIRE ET ORTHOGRAPHE GRAMMATICALE":
    case "ETUDE DE LA LANGUE":
      return "Langue";
    case "CULTURE LITTERAIRE ET ARTISTIQUE":
      return "Culture Lit.";
      
    default:
      return theme || "Non défini";
  }
}

// Fonction pour matcher le thème avec themeDetail
function findMatchingTheme(sequenceTheme) {
  if (!ThemeDetail || !sequenceTheme) return null;
  
  const normalizedSeqTheme = sequenceTheme
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .trim();
  
  return ThemeDetail.find(theme => {
    const normalizedThemeName = theme.nom
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase()
      .trim();
    
    if (normalizedThemeName === normalizedSeqTheme) return true;
    
    // MATHS
    if (normalizedSeqTheme.includes("NOMBRE") && normalizedThemeName.includes("NOMBRE")) return true;
    if (normalizedSeqTheme.includes("ESPACE") && normalizedThemeName.includes("ESPACE")) return true;
    if (normalizedSeqTheme.includes("GRANDEURS") && normalizedThemeName.includes("GRANDEURS")) return true;
    if (normalizedSeqTheme.includes("ORGANISATION") && normalizedThemeName.includes("ORGANISATION")) return true;
    if (normalizedSeqTheme.includes("PROPORTIONNALITE") && normalizedThemeName.includes("PROPORTIONNALITE")) return true;
    if (normalizedSeqTheme.includes("INFORMATIQUE") && normalizedThemeName.includes("INFORMATIQUE")) return true;
    if (normalizedSeqTheme.includes("ALGORITHMIQUE") && normalizedThemeName.includes("ALGORITHMIQUE")) return true;
    
    // FRANÇAIS
    if (normalizedSeqTheme.includes("LANGAGE") && normalizedThemeName.includes("LANGAGE")) return true;
    if (normalizedSeqTheme.includes("LECTURE") && normalizedThemeName.includes("LECTURE")) return true;
    if (normalizedSeqTheme.includes("ECRITURE") && normalizedThemeName.includes("ECRITURE")) return true;
    if (normalizedSeqTheme.includes("VOCABULAIRE") && normalizedThemeName.includes("VOCABULAIRE")) return true;
    if (normalizedSeqTheme.includes("GRAMMAIRE") && normalizedThemeName.includes("GRAMMAIRE")) return true;
    if (normalizedSeqTheme.includes("ETUDE DE LA LANGUE") && normalizedThemeName.includes("ETUDE DE LA LANGUE")) return true;
    if (normalizedSeqTheme.includes("CULTURE") && normalizedThemeName.includes("CULTURE")) return true;
    
    return false;
  });
}
  // Toggle attendu selection
  const toggleAttendu = (seqIdx, attenduId, attenduDesc) => {
    setSelectedAttendus(prev => {
      const seqKey = `seq_${seqIdx}`;
      const currentAttendus = prev[seqKey] || [];
      
      const exists = currentAttendus.find(a => a.id === attenduId);
      
      if (exists) {
        return {
          ...prev,
          [seqKey]: currentAttendus.filter(a => a.id !== attenduId)
        };
      } else {
        return {
          ...prev,
          [seqKey]: [...currentAttendus, { id: attenduId, description: attenduDesc }]
        };
      }
    });
  };

  // Toggle descripteur
  const toggleDescripteur = (seqIdx, descId) => {
    const key = `${seqIdx}_${descId}`;
    setExpandedDescripteurs(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // Vérifier si un attendu est sélectionné
  const isAttenduSelected = (seqIdx, attenduId) => {
    const seqKey = `seq_${seqIdx}`;
    return selectedAttendus[seqKey]?.some(a => a.id === attenduId) || false;
  };

  // Une SÉQUENCE ne porte que des OBJECTIFS (décision 2026-08-18) : les
  // automatismes du référentiel sont invisibles à l'import de progression.
  const attendusVisibles = (descripteur) => attendusDeRubrique(descripteur?.attendus, 'objectif');

  // Compter les attendus sélectionnés pour un descripteur
  const getSelectedCountForDescripteur = (seqIdx, descripteur) => {
    const seqKey = `seq_${seqIdx}`;
    const selected = selectedAttendus[seqKey] || [];
    return attendusVisibles(descripteur).filter(att =>
      selected.some(s => s.id === att.id)
    ).length;
  };

  // Compter tous les attendus sélectionnés
  const getSelectedCount = (seqIdx) => {
    return selectedAttendus[`seq_${seqIdx}`]?.length || 0;
  };

// Ajouter cette fonction helper au début du composant
const getVacationBetweenPeriods = (currentPeriod, nextPeriod) => {
  if (!currentPeriod || !nextPeriod) return null;
  
  const finPeriode = new Date(currentPeriod.date_fin);
  const debutNextPeriode = new Date(nextPeriod.date_debut);
  
  // Calculer la durée des vacances
  const joursVacances = Math.floor((debutNextPeriode - finPeriode) / (1000 * 60 * 60 * 24));
  const semainesVacances = Math.ceil(joursVacances / 7);
  
  return {
    debut: finPeriode,
    fin: debutNextPeriode,
    duree: semainesVacances
  };
};


 return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl">
      {/* Header */}
      <div className="flex items-center justify-between p-6 xl:p-3 2xl:p-4 3xl:p-6 pb-4 xl:pb-2 2xl:pb-3 3xl:pb-4 border-b border-blue-100/50">
        <h3 className="text-xl xl:text-sm 2xl:text-base 3xl:text-xl font-bold text-gray-800 flex items-center gap-3">
          <Calendar className="w-6 h-6 xl:w-4 xl:h-4 2xl:w-5 2xl:h-5 3xl:w-6 3xl:h-6 text-blue-600" />
          Prévisualisation de la progression
        </h3>
        <div className="text-sm xl:text-xs 2xl:text-xs 3xl:text-sm text-gray-600 bg-white px-4 xl:px-2 2xl:px-3 3xl:px-4 py-2 xl:py-1 2xl:py-1.5 3xl:py-2 rounded-full shadow-sm">
          {sequencesWithDates.length} séquences
        </div>
      </div>

      {/* Timeline - contenu scrollable */}
      <div className="px-6 xl:px-3 2xl:px-4 3xl:px-6">
        <div className="space-y-3 pb-4">
          {sequencesWithDates.map((seq, idx) => {
            const matchedTheme = findMatchingTheme(seq.theme);
            // Vérifier si on change de période pour la prochaine séquence
            const nextSeq = sequencesWithDates[idx + 1];
            const showVacation = nextSeq && seq.periode !== nextSeq.periode;
            const vacation = showVacation ? getVacationBetweenPeriods(
              periodes.find(p => p.numero === seq.periode),
              periodes.find(p => p.numero === nextSeq.periode)
            ) : null;

            // Vérifier si des attendus sont sélectionnés
            const hasSelectedAttendus = getSelectedCount(idx) > 0;

            return (
              <div key={idx}>
                <div
                  className={`bg-white rounded-xl p-4 xl:p-2 2xl:p-3 3xl:p-4 shadow-sm hover:shadow-md transition-all duration-300 border-l-4 ${getThemeBorderColor(seq.theme)}`}
                >
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-2 flex-wrap">
                        <span className="bg-blue-100 text-blue-700 text-xs font-bold px-2 py-1 rounded-full">
                          #{idx + 1}
                        </span>

                        {/* Badge du thème avec couleur */}
                        <span className={`text-xs font-bold px-3 py-1 rounded-full border ${getThemeBadgeColor(seq.theme)} flex items-center gap-1`}>
                          <BookOpen className="w-3 h-3" />
                          {getShortThemeName(seq.theme)}
                        </span>

                        <h4 className="font-semibold text-gray-800 xl:text-xs 2xl:text-sm 3xl:text-base">{seq.titre}</h4>

                        {/* Bouton Attendus avec animation pour inciter au clic */}
                        <button
                          onClick={() => setExpandedSequence(expandedSequence === idx ? null : idx)}
                          className={`
                            relative flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-full
                            transition-all duration-300 transform
                            ${hasSelectedAttendus
                              ? 'bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-md shadow-green-200'
                              : 'bg-gradient-to-r from-blue-500 to-sky-500 text-white shadow-md shadow-blue-200 animate-pulse-soft hover:animate-none'
                            }
                            hover:scale-105 hover:shadow-lg
                            ${expandedSequence === idx ? 'ring-2 ring-offset-2 ring-blue-400' : ''}
                          `}
                        >
                          {/* Indicateur de "à faire" */}
                          {!hasSelectedAttendus && (
                            <span className="absolute -top-1 -right-1 flex h-3 w-3">
                              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                              <span className="relative inline-flex rounded-full h-3 w-3 bg-amber-500"></span>
                            </span>
                          )}

                          <Plus className={`w-3.5 h-3.5 transition-transform duration-300 ${expandedSequence === idx ? 'rotate-45' : ''}`} />
                          <span>Attendus</span>

                          {hasSelectedAttendus && (
                            <span className="ml-1 px-1.5 py-0.5 bg-white/30 text-white rounded-full text-xs font-bold">
                              {getSelectedCount(idx)}
                            </span>
                          )}

                          {expandedSequence === idx ? (
                            <ChevronUp className="w-3.5 h-3.5" />
                          ) : (
                            <ChevronDown className="w-3.5 h-3.5" />
                          )}
                        </button>

                        <span className="bg-purple-100 text-purple-700 text-xs px-2 py-1 rounded-full ml-auto">
                          Période {seq.periode}
                        </span>
                      </div>

                      <div className="flex items-center gap-6 xl:gap-3 2xl:gap-4 3xl:gap-6 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">
                        <div className="flex items-center gap-2 text-gray-600">
                          <Clock className="w-4 h-4" />
                          <span>{Number(seq.duree.toFixed(1))} semaine{seq.duree > 1 ? 's' : ''}</span>
                        </div>

                        <div className="flex items-center gap-2">
                          <div className="flex items-center gap-1 text-green-600">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            <span className="font-medium">
                              {new Date(seq.dateDebut).toLocaleDateString('fr-FR', {
                                day: 'numeric',
                                month: 'short'
                              })}
                            </span>
                          </div>

                          <span className="text-gray-400">→</span>

                          <div className="flex items-center gap-1 text-red-600">
                            <span className="font-medium">
                              {new Date(seq.dateFin).toLocaleDateString('fr-FR', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric'
                              })}
                            </span>
                            <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Attendus sélectionnés affichés */}
                  {selectedAttendus[`seq_${idx}`]?.length > 0 && expandedSequence !== idx && (
                    <div className="mt-2 flex flex-wrap gap-1">
                      {selectedAttendus[`seq_${idx}`].slice(0, 2).map((att, i) => (
                        <span key={i} className="text-xs px-2 py-1 bg-green-100 text-green-700 rounded-full" title={att.description}>
                          {att.description.substring(0, 40)}...
                        </span>
                      ))}
                      {selectedAttendus[`seq_${idx}`].length > 2 && (
                        <span className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded-full">
                          +{selectedAttendus[`seq_${idx}`].length - 2} autres
                        </span>
                      )}
                    </div>
                  )}

                  {/* Section attendus dépliée */}
                  {expandedSequence === idx && matchedTheme && (
                    <div className="mt-3 p-4 xl:p-2 2xl:p-3 3xl:p-4 bg-gradient-to-br from-blue-50/50 to-sky-50/50 rounded-xl border border-blue-100">
                      <h5 className="font-medium text-sm xl:text-xs 2xl:text-xs 3xl:text-sm text-gray-700 mb-3 xl:mb-2 2xl:mb-2 3xl:mb-3 flex items-center gap-2">
                        <BookOpen className="w-4 h-4 text-blue-500" />
                        Sélectionner les attendus pour cette séquence :
                      </h5>

                      <div className="space-y-2">
                        {matchedTheme.descripteur.map((desc) => (
                          <div key={desc.id} className="border border-gray-200 rounded-lg bg-white">
                            <button
                              onClick={() => toggleDescripteur(idx, desc.id)}
                              className="w-full flex items-center justify-between p-3
                                bg-gradient-to-r from-gray-50 to-slate-50 rounded-lg
                                hover:from-blue-50 hover:to-sky-50 transition-all duration-200
                                text-sm text-gray-800"
                            >
                              <span className="font-medium text-left">{desc.nom}</span>
                              <div className="flex items-center gap-2">
                                {attendusVisibles(desc).length > 0 && (
                                  <span className={`text-xs px-2 py-0.5 rounded-full ${
                                    getSelectedCountForDescripteur(idx, desc) > 0
                                      ? 'bg-green-100 text-green-700'
                                      : 'bg-gray-100 text-gray-500'
                                  }`}>
                                    {getSelectedCountForDescripteur(idx, desc)}/{attendusVisibles(desc).length}
                                  </span>
                                )}
                                {expandedDescripteurs[`${idx}_${desc.id}`] ?
                                  <ChevronUp className="w-4 h-4 text-gray-500" /> :
                                  <ChevronDown className="w-4 h-4 text-gray-500" />
                                }
                              </div>
                            </button>

                            {expandedDescripteurs[`${idx}_${desc.id}`] && desc.attendus && (
                              <div className="p-3 pt-0 space-y-1">
                                {attendusVisibles(desc).map((attendu) => (
                                  <label
                                    key={attendu.id}
                                    className={`flex items-start gap-2 p-2 rounded-lg cursor-pointer text-sm transition-colors ${
                                      isAttenduSelected(idx, attendu.id)
                                        ? 'bg-green-50 border border-green-200'
                                        : 'hover:bg-gray-50'
                                    }`}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={isAttenduSelected(idx, attendu.id)}
                                      onChange={() => toggleAttendu(idx, attendu.id, attendu.description)}
                                      className="mt-0.5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                    />
                                    <span className="text-gray-700 text-xs leading-relaxed">
                                      <MathText>{attendu.description}</MathText>
                                      {attendu.niveau && (
                                        <span className="ml-2 text-gray-500">({attendu.niveau})</span>
                                      )}
                                    </span>
                                  </label>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Indicateur de vacances */}
                {vacation && (
                  <div className="flex items-center justify-center my-2">
                    <div className="flex items-center gap-3 px-4 py-2 bg-gradient-to-r from-yellow-50 to-orange-50 rounded-full border border-yellow-300">
                      <span className="text-2xl">🏖️</span>
                      <span className="text-sm font-medium text-yellow-800">
                        Vacances ({vacation.duree} semaine{vacation.duree > 1 ? 's' : ''})
                      </span>
                      <span className="text-xs text-yellow-600">
                        {vacation.debut.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })} →
                        {vacation.fin.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Animation CSS pour le bouton */}
      <style>{`
        @keyframes pulse-soft {
          0%, 100% {
            opacity: 1;
            box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.3), 0 2px 4px -1px rgba(59, 130, 246, 0.2);
          }
          50% {
            opacity: 0.9;
            box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.4), 0 4px 6px -2px rgba(59, 130, 246, 0.3);
          }
        }
        .animate-pulse-soft {
          animation: pulse-soft 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
      `}</style>
    </div>
  );
};


export default PreviewSequence;